import {Component, Inject, OnInit} from '@angular/core';
import {ErrorResponse} from '../../model/error-response';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'simple-error-dialog',
  templateUrl: './simple-error-dialog.component.html',
  styleUrls: ['./simple-error-dialog.component.scss']
})
export class SimpleErrorDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SimpleErrorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ErrorResponse) {}

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
